import React, { useMemo, useCallback } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

const FormContactKREZCO = ({ data, page, setPage }) => {
  const [companyData, setData] = data;

  const validations = useMemo(
    () =>
      Yup.object().shape({
        contactName: Yup.string().required("No puede estar vacio"),
        contactId: Yup.string()
          .required("No puede estar vacio")
          .min(14, "Ingrese Número de cédula Valido sin guiones")
          .max(14, "El número de cedula no puede ser mayor a 14 digitos"),
        contactPhone: Yup.number() //
          .integer("No puede tener decimales")
          .test(
            "test-name",
            "Ingrese un número de teléfono válido de 8 dígitos.",
            (value) => {
              return (
                !value ||
                (value &&
                  Number.isInteger(value) &&
                  value.toString().length >= 8 &&
                  value.toString().length <= 8)
              );
            }
          )
          .typeError(
            "No debe incluir caracteres especiales, como #@&%-/, ni caracteres alfabéticos [A-Z, a-z]."
          ),
        contactCellPhone: Yup.number() //
          .integer("No puede tener decimales")
          .test(
            "test-name",
            "Ingrese un número de teléfono válido de 8 dígitos.",
            (value) => {
              return (
                !value ||
                (value &&
                  Number.isInteger(value) &&
                  value.toString().length >= 8 &&
                  value.toString().length <= 8)
              );
            }
          )
          .typeError(
            "No debe incluir caracteres especiales, como #@&%-/, ni caracteres alfabéticos [A-Z, a-z]."
          ),
      }),
    []
  );

  const formSubmit = useCallback(
    async (values, { setSubmitting }) => {
      setSubmitting(true);
      setData((prev) => {
        return {
          ...prev,
          contact: values,
        };
      });

      setPage((prev) => prev + 1);
      setSubmitting(false);
    },
    [setPage, page]
  );

  return (
    <Formik
      initialValues={companyData["contact"]}
      onSubmit={formSubmit}
      validationSchema={validations}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <div className="form__companytitle text-center">
            INFORMACIÓN DE LA PERSONA CONTACTO EN LA EMPRESA PARA KREZCO
          </div>

          <div className="form__row row">
            <div className="col-sm-12 col-md-12">
              <label htmlFor="username">Nombre de Contacto</label>
              <Field type="text" name="contactName" id="contactName" />
              {errors.contactName && (
                <span className="form__validation form__validation--error">
                  {errors.contactName}
                </span>
              )}
            </div>
          </div>

          <div className="form__row row">
            <div className="col-sm-12 col-md-12">
              <label htmlFor="username">
                Cédula de contacto <span>sin guiones</span>
              </label>
              <Field
                type="text"
                name="contactId"
                id="contactId"
                max={14}
              ></Field>
              {errors.contactId && (
                <span className="form__validation form__validation--error">
                  {errors.contactId}
                </span>
              )}
            </div>
          </div>
          <div className="form_row row">
            <div className="col-sm-12 col-md-6">
              <label htmlFor="telephone">Teléfono de la persona</label>
              <Field type="tel" name="contactPhone" id="contactPhone" />
              {errors.contactPhone && (
                <span className="form__validation form__validation--error">
                  {errors.contactPhone}
                </span>
              )}
              <span className="form__validation"></span>
            </div>

            <div className="col-sm-12 col-md-6">
              <label htmlFor="telephone">Celular de la persona</label>
              <Field
                type="tel"
                name="contactCellPhone"
                id="contactCellPhone"
              ></Field>
              {errors.contactCellPhone && (
                <span className="form__validation form__validation--error">
                  {errors.contactCellPhone}
                </span>
              )}
              <span className="form__validation"></span>
            </div>
            <div className="col-sm-12 col-md-4 mb-2"></div>
          </div>

          <div className="form_row row">
            <div className="col-sm-12 col-md-6">
              <button
                onClick={() => setPage(page - 1)}
                className="btn btn--gradient btn__icon btn__icon--door"
              >
                Atrás
              </button>
            </div>

            <div className="col-sm-12 col-md-6">
              <button
                type="submit"
                className="btn btn--gradient btn__icon btn__icon--door"
              >
                Siguiente
              </button>
            </div>
            <div className="col-sm-12 col-md-4 mb-2"></div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FormContactKREZCO;
